export default "__VITE_ASSET__V17U8bLX__"